'use client';

var translations = {
    'Do you want to see your competitive analysis?': 'Bạn muốn phân tích CV trước khi ứng tuyển?',
    'View competitive analysis before applying': 'Xem phân tích mức độ cạnh tranh trước khi ứng tuyển',
    'View competitive analysis': 'Xem phân tích mức độ cạnh tranh',
    'Competitive Analysis': 'Phân tích mức độ cạnh tranh',
    'What percentage are you suitable for this position?': 'Bạn phù hợp bao nhiêu % cho vị trí này?',
    'What is your ranking compared to other applicants?': 'Bạn xếp hạng Top bao nhiêu so với những hồ sơ ứng tuyển?',
    'What is the market salary for similar positions?': 'Thị trường đang trả mức lương bao nhiêu cho vị trí tương tự?',
    'Is the demand for this position on the market high or low?': 'Nhu cầu tuyển dụng cho vị trí này trên thị trường cao hay thấp?',
    'Trial price': 'Giá dùng thử',
    'View analysis now': 'Xem đánh giá ngay',
    '/cv-review': '/phan-tich-ho-so',
    'See report': 'Xem đánh giá',
    'Evaluated on': 'Đánh giá',
    'Matching rate to job requirements': 'Độ phù hợp với công việc',
    'Comparison with other applicants': 'So với ứng viên khác',
    'Evaluate another CV': 'Đánh giá hồ sơ khác',
    'You can use this feature multiple times with different CVs.': 'Bạn có thể sử dụng tính năng này nhiều lần với nhiều CV khác nhau.',
    time: 'lượt',
    High: 'Cao',
    Low: 'Thấp',
    Medium: 'Trung bình',
    'Very high': 'Rất cao',
    Rank: 'Xếp hạng',
    'Try for free': 'Dùng thử miễn phí',
    'You have {0} free trial': 'Bạn có {0} lần dùng thử miễn phí',
    '{0} free trial remaining': 'Còn {0} lần dùng thử',
    Price: 'Giá',
    'View analysis': 'Xem phân tích',
    'How you match this job?': 'Bạn phù hợp bao nhiêu %?',
    'Your ranking vs. other application?': 'Xếp hạng so với ứng viên khác?',
    'Market salary for this position?': 'Mức lương thị trường đang trả?',
    'Hiring demand for this position?': 'Nhu cầu tuyển dụng của ngành?'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
